<template lang="pug">
ul.portfolio
  li.portfolio__item(
    v-for="item in block.items"
    :key="item.title")
    a.portfolio__link(:href="item.href")
      div.portfolio__image-wrapper
        div.portfolio__image-box
          img.portfolio__image(
            :src="getSrc(item.src)"
            :alt="item.title")
      span.portfolio__type(v-html="item.type")
      h5.portfolio__title(v-html="item.title")
      span.portfolio__text(v-html="item.description")
</template>

<script>
export default {
  name: 'PortfolioComponent',
  props: {
    block: {
      type: Object,
      default: () => {},
    }
  },
  methods: {
    getSrc(src) {
      return require(`~/assets/images/${src}`)
    },
  },
}
</script>

<style lang='scss' scoped>
.portfolio {
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 1440px) {
    flex-direction: column;
  }

  &__item {
    flex-basis: calc((100% - 2 * 18px) / 3);

    @media screen and (max-width: 1440px) {
      flex-basis: 100%;
      margin-bottom: 2.5rem;
    }
  }

  &__link,
  &__type,
  &__title,
  &__text {
    display: block;
  }

  &__link {
    &:hover {
      text-decoration: none;
    }
  }

  &__image-wrapper,
  &__image-box {
    display: contents;
  }

  &__image {
    width: 100%;
    margin-bottom: 0.4rem;
    object-fit: cover;

    @media screen and (max-width: 1440px) {
      width: 100%;
      aspect-ratio: 2.22;
      margin-bottom: 1rem;
    }
  }

  &__type {
    color: $primary;
    font-size: 12px;
    font-weight: bold;
  }

  &__title {
    font-size: 16px;
    font-weight: bold;
    margin: 0.8rem 0;
    color: $dark;
  }

  &__text {
    font-size: 14px;
    line-height: 1.4;
    color: $dark;
  }
}

@supports not (aspect-ratio: 2.22) {
  .portfolio {
    &__image-wrapper {
      @media screen and (max-width: 1440px) {
        display: block;
        height: 0;
        overflow: hidden;
        padding-top: calc(151px / 335px * 100%);
        position: relative;
      }
    }

    &__image-box {
      @media screen and (max-width: 1440px) {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
